import React from "react";
import { Link } from "react-router-dom";

function Logo() {
  return (
    <Link className="logo" to="/">
      <img src="/images/logo.png" alt="logo" />
    </Link>
  );
}

export default Logo;
